export const isScooterActon = (scooterName?: string | number | undefined) => {
    if (!scooterName) return false;

  return (
    (Number(scooterName) > 899 && Number(scooterName) < 1201) ||
    (Number(scooterName) > 300 && Number(scooterName) < 332)
  );
};
